import { render, staticRenderFns } from "./mainr.vue?vue&type=template&id=71123ee0&scoped=true&"
import script from "./mainr.vue?vue&type=script&lang=js&"
export * from "./mainr.vue?vue&type=script&lang=js&"
import style0 from "./mainr.vue?vue&type=style&index=0&id=71123ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71123ee0",
  null
  
)

export default component.exports